export const textItemsFromField = (item:{text:string}[], callback:(text:string, index:number) => any) => 
    item && item.map(({text}:{text:string}, index) => callback(text, index));